import { FormattedMessage } from 'react-intl'
import { NavLink } from 'react-router-dom'

import { TabsWrapper, Tabs, Tab } from 'components/Tabs'
import { ReactElement } from 'react'

export const LoyaltyTabs = (): ReactElement => {
  return (
    <TabsWrapper>
      <Tabs>
        <Tab as={NavLink} to="/loyalty/campaigns">
          <FormattedMessage id="spanish.loyalty.tabs.detail" defaultMessage="Detail" />
        </Tab>

        <Tab hidden as={NavLink} to="/loyalty/tracking">
          <FormattedMessage id="spanish.loyalty.tabs.tracking" defaultMessage="Tracking" />
        </Tab>
      </Tabs>
    </TabsWrapper>
  )
}
